//node modules
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

//global context
import { useAppState } from "../../context/state";

//components
import { Element as ScrollElement } from "react-scroll";

//images
import navLogo from "../../media/images/logo.png";
import dugnadLogo from "../../media/images/dugnad.png";
import dugnadLogoDark from "../../media/images/dugnadDarkMode.png";
import useUrlRef from "../../global/hooks/useUrlRef";
import SignOutUser from "../../pages/development/SignOutUser";

export default function Navigation() {
  const { appState } = useAppState();
  const [isDarkMode, setIsDarkMode] = useState(false);

  const location = useLocation();

  const { urlRef } = useUrlRef();
  const logoLink =
    urlRef && (urlRef !== location.pathname || location.pathname !== "/")
      ? urlRef
      : "/";

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function" ||
      typeof navigator === "undefined"
    )
      return;

    const isAndroid = /Android/i.test(navigator.userAgent);
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const updateMode = () => setIsDarkMode(isAndroid && mediaQuery.matches);

    updateMode();
    mediaQuery.addEventListener("change", updateMode);
    return () => mediaQuery.removeEventListener("change", updateMode);
  }, []);

  const logoSrc = isDarkMode ? dugnadLogoDark : dugnadLogo;

  return (
    <>
      <nav className={`nav`}>
        <ScrollElement name={"navigation"} className={"nav_container"}>
          <div className={`nav-left`}>
            <Link className={"nav-logo"} to={logoLink}>
              <img src={logoSrc} alt="tuttilodd logo" />
            </Link>
          </div>
          <div className={`nav-right`}>
            <ul className={"nav-links"}>
              <a className={"link nav-link"} href={"https://info.dugnad.org"}>
                Om dugnad.org
              </a>
            </ul>
          </div>
          <div
            style={{
              right: 1,
            }}>
            <SignOutUser />
          </div>
        </ScrollElement>
      </nav>
    </>
  );
}
